"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarLogistics = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
class SolarLogistics extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.SOLAR_LOGISTICS,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.SPACE],
            cost: 20,
            cardDiscount: { tag: Tags_1.Tags.EARTH, amount: 2 },
            metadata: {
                cardNumber: 'X63',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect(undefined, (eb) => {
                        eb.earth().played.startEffect.megacredits(-2);
                    });
                    b.br;
                    b.effect('When you play an Earth tag, you pay 2 M€ less for it. When any player plays a Space event, you draw a card.', (eb) => {
                        eb.space().played.any.nbsp(Size_1.Size.SMALL).event().played.any.startEffect.cards(1);
                    });
                    b.br.br;
                    b.titanium(2).text('(Gain 2 titanium.)', Size_1.Size.DESCRIPTION, false, false);
                }),
                victoryPoints: 1,
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.TITANIUM, 2);
        return undefined;
    }
    getCardDiscount(_player, card) {
        return card.tags.filter((tag) => tag === Tags_1.Tags.EARTH).length * 2;
    }
    onCardPlayed(player, card) {
        const owner = player.game.getCardPlayer(this.name);
        if (card.cardType === CardType_1.CardType.EVENT && card.tags.includes(Tags_1.Tags.SPACE)) {
            player.canUndoLastAction = false;
            owner.drawCard();
        }
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.SolarLogistics = SolarLogistics;
//# sourceMappingURL=SolarLogistics.js.map